import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import ModalCustom from '../../modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import LabelCustom from '../../label-custom'
import Error_false from '../../error/error-false'
import Swal from 'sweetalert2'
import SwalCustom from '../../../alert/swal-custom'
import UseTypeHoliday from '../../../hooks/use-type-holiday'
import DatepickerCustom from '../../datepicker-custom'
import moment from 'moment'
import { postHolidayAPI } from '../../../services/holiday'
import { TXTSUCCESS } from '../../../Constants'
import AutocompleteCustom from '../../custom/autocomplete'

const schema = yup
  .object({
    type: yup.object().required('Please, Input type'),
    date: yup.string().required('Please, Input date'),
    detail: yup.string().required('Please, Input detail')
  })
  .required()
export default function AddHoliday({
  setIsSave,
  showCreate,
  isSave,
  fnGetData,
  setShowCreate
}) {
  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  const type = UseTypeHoliday()

  const onSubmit = (d) => {
    const body = {
      holidayTypeId: d.type.value ?? '',
      holidayDate: d.date ?? '',
      holidayDetail: d.detail ?? ''
    }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to create new?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        createHoliday(body)
      }
    })
  }

  const createHoliday = async (body) => {
    const results = await postHolidayAPI(body)
    setIsSave(false)
    if (!results) {
      return
    }
    if (results.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        fnGetData()
        Swal.close()
      })
    } else {
      Error_false(results)
    }
    setIsSave(false)
    fnReset()
    handleClose()
  }

  const fnReset = () => {
    setError('type', false)
    setError('date', false)
    setError('detail', false)
  }

  const handleClose = () => {
    setShowCreate(false)
    fnReset()
  }

  return (
    <ModalCustom width={500} open={showCreate} onCancel={handleClose}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label>Add Holiday</label>

        <Col md={12}>
          <LabelCustom text={'Type'} />
          <Controller
            name={'type'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <AutocompleteCustom
                value={value}
                onChange={onChange}
                isClearable={false}
                options={type}
                className="w-100"
              />
            )}
          />
          {errors.type?.message && (
            <label className="small text-danger">{errors.type.message}</label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Date'} />
          <Controller
            name={'date'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <DatepickerCustom
                clearSearch
                value={value}
                onChange={([date]) => {
                  setValue(
                    'date',
                    date ? moment(date).format('YYYY-MM-DD') : ''
                  )
                  setError('date', date)
                }}
              />
            )}
          />
          {errors.date?.message && (
            <label className="small text-danger">{errors.date.message}</label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Detail'} />
          <Controller
            name="detail"
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                as="textarea"
                maxLength={250}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors.detail?.message && (
            <label className="small text-danger">{errors.detail.message}</label>
          )}
        </Col>

        <Col xl={12} className="text-center">
          <Button
            className="px-4 me-2 bg-secondary text-white"
            variant="light"
            type="button"
            onClick={handleClose}
          >
            Close
          </Button>
          <Button type="submit" className="px-4" disabled={isSave}>
            {isSave ? 'Saving...' : 'Save'}
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
